// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Z8h1"};